import {Component, Renderer2} from '@angular/core';
import {SplitterModule} from "primeng/splitter";
import {TableModule, TableRowCollapseEvent, TableRowExpandEvent} from "primeng/table";
import {Button} from "primeng/button";
import {RatingModule} from "primeng/rating";
import {TagModule} from "primeng/tag";
import {TaskService} from "../../sipo/services/task.service";
import {MessageService} from "primeng/api";
import {FormsModule} from "@angular/forms";
import {Ripple} from "primeng/ripple";
import {SidebarModule} from "primeng/sidebar";
import {TaskDetailsComponent} from "../task-details/task-details.component";
import {TaskStatusIconComponent} from "../../shared/components/task-status-icon/task-status-icon.component";
import {AccordionModule} from "primeng/accordion";
import {TaskKanbanComponent} from "../task-kanban/task-kanban.component";
import {KanbanAppComponent} from "../kanban/kanban.app.component";
import {TaskDetailsSidebarService} from "../services/task-details-sidebar.service";
import {ThisReceiver} from "@angular/compiler";
import {NgIf} from "@angular/common";
import { TranslateModule } from '@ngx-translate/core';
import {ITask} from "../shared/models/task.model";

@Component({
    selector: 'app-task-list',
    standalone: true,
    imports: [
        SplitterModule,
        TableModule,
        Button,
        RatingModule,
        TagModule,
        FormsModule,
        Ripple,
        SidebarModule,
        TaskDetailsComponent,
        TaskStatusIconComponent,
        AccordionModule,
        KanbanAppComponent,
        NgIf,
        TranslateModule
    ],
    templateUrl: './task-list.component.html',
    styleUrl: './task-list.component.scss'
})
export class TaskListComponent {

    tasks!: ITask[];
    taskTitle!: string;
    currentRightContent: string = 'default';
    dividerLayout: string = 'horizontal';

    expandedRows = {};

    constructor(private taskService: TaskService, private messageService: MessageService, private renderer: Renderer2, public taskDetailsSidebarService: TaskDetailsSidebarService) {
    }

    ngOnInit() {

        this.tasks = this.taskService.getTasksWithSubtasksData();

        this.getLayout()
    }

    getLayout() {
        if (window.innerWidth < 768) {
            this.dividerLayout = 'vertical'; // Change to vertical layout on small screens
        } else {
            this.dividerLayout = 'horizontal'; // Default to horizontal layout on larger screens
        }
    }

    filterTasksArrData(state: string) {

        this.currentRightContent !== 'default' && (this.currentRightContent = 'default');

        this.tasks = this.taskService.getTasksWithSubtasksData().filter(task => {
            console.log(task.state)
            return task.state === state;
        });
    }

    getTaskTitle(title: string) {
        this.taskTitle = title;
    }

    changeCurrentRightContent(currentRightContentParam: string) {
        this.currentRightContent = currentRightContentParam;
    }

    openDetails() {
        const html = document.querySelector('html');
        if (html) {
            this.renderer.addClass(html, 'no-scrollbar');
        }
        this.taskDetailsSidebarService.isDetailsVisible = true;
    }

    getBackScrollbar() {
        const html = document.querySelector('html');
        if (html) {
            this.renderer.removeClass(html, 'no-scrollbar');
        }
    }

    onRowExpand(event: TableRowExpandEvent) {
        this.messageService.add({severity: 'info', summary: 'Product Expanded', detail: event.data.name, life: 3000});
    }

    onRowCollapse(event: TableRowCollapseEvent) {
        this.messageService.add({
            severity: 'success',
            summary: 'Task Collapsed',
            detail: event.data.name,
            life: 3000
        });
    }
}
